export default "__VITE_ASSET__BLte3DY8__"